var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[(_vm.appBarIsVisible)?_c('app-bar',{attrs:{"appBarColor":_vm.appBarColor,"appLogo":_vm.appLogo}}):_vm._e(),_c('v-main',[_c('router-view',{key:String(_vm.$route.name || '').replace(/^custom-/, '') === 'document-list' ? _vm.$route.fullPath : undefined})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }